module.exports = __webpack_public_path__ + "static/media/1027021.c4ef734e.png";